import React, { useState, useEffect, Component } from "react";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import TableView from "../../TableView";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AirwayBillFirstPage = ({
  onhandleBLNunber,
  onhadlePlaceofDelivery,
  onhadleMasterBL,
  onhadleHouseBL,
  onhadleBLDate,
  onhadleConsignee,
  onhadleNotyfyParty,
  onhadleDeliverGoods,
  onhadlePlaceOfReceipt,
  onhadlePreCarrageBy,
  onhadleVesCode,
  onhadleVesDesc,
  onhadlevoyCode,
  onhadlePolCode,
  onhadleVoyDesc,
  onhadlepodCode,
  onhadlePolDesc,
  onhadlepodDesc,
  onhadleFinalDestination,
  onhadleGrossWeight,
  onhadleNoOfCont,
  onhadleMesurement,
  onhadleNoOfContInWords,
  onhadleShipper,
}) => {
  const [baseUrl, setBaseUrl] = useState("http://mol.evolve-demo.com/api/");
  const [pageComponent, setPageComponent] = useState("airexportbl");
  const [blNumList, setBlNumList] = useState(undefined);
  const [selectedBLNO, setSelectedBLNO] = useState("");

  const [firstFlightDateTextBoxes, setFirstFlightDateTextBoxes] = useState(1);
  const [firstFlightDate, setFirstFlightDate] = useState([""]);
  const [flightDateList, setFlightDateList] = useState([]);

  const [houseBL, setHouseBL] = useState("");
  const [nowHouseBL, setNowHouseBL] = useState("");
  const [houseBLOn, setHouseBLOn] = useState(false);

  const [bLDate, setBLDate] = useState("");
  const [nowBLDate, setNowBLDate] = useState("");
  const [bLDateOn, setBLDateOn] = useState(false);

  const [vesCode, setVesCode] = useState("vessel code");
  const [vesDesc, setVesDesc] = useState("vessel Description");
  const [voyCode, setVoyCode] = useState("Voyage code");
  const [voyDesc, setVoyDesc] = useState("Voyage Description");
  const [polCode, setPolCode] = useState("Port looding code");
  const [polDesc, setPolDesc] = useState("Port looding Description");
  const [podCode, setPodCode] = useState("Port looding code");
  const [podDesc, setPodDesc] = useState("Port looding Description");

  const [placeofDelivery, setPlaceofDelivery] = useState("");
  const [nowPlaceofDelivery, setNowPlaceofDelivery] = useState("");
  const [placeofDeliveryOn, setPlaceofDeliveryOn] = useState(false);

  const [preCarrageBy, setPreCarrageBy] = useState("");
  const [NowPreCarrageBy, setNowPreCarrageBy] = useState("");
  const [preCarrageByOn, setPreCarrageByOn] = useState(false);

  const [placeOfReceipt, setPlaceOfReceipt] = useState("");
  const [NowPlaceOfReceipt, setNowPlaceOfReceipt] = useState("");
  const [placeOfReceiptOn, setPlaceOfReceiptOn] = useState(false);

  const [finalDestination, setFinalDestination] = useState("");
  const [NowFinalDestination, setNowFinalDestination] = useState("");
  const [finalDestinationOn, setFinalDestinationOn] = useState(false);

  const [grossWeight, setGrossWeight] = useState("");
  const [NowgrossWeight, setNowGrossWeight] = useState("");
  const [grossWeightOn, setGrossWeightOn] = useState(false);

  const [noOfCont, setNoOfCont] = useState("");
  const [nownoOfCont, setNowNoOfCont] = useState("");
  const [noOfContOn, setNoOfContOn] = useState(false);

  const [mesurement, setMesurement] = useState("");
  const [nowmesurement, setNowMesurement] = useState("");
  const [mesurementOn, setMesurementOn] = useState(false);

  const [shipper, setShipper] = useState("");
  const [nowshipper, setNowShipper] = useState("");
  const [shipperOn, setShipperOn] = useState(false);

  const [noOfContInWords, setNoOfContInWords] = useState("");
  const [nowNoOfContInWords, setNowNoOfContInWords] = useState("");
  const [noOfContInWordsOn, setNoOfContInWordsOn] = useState(false);

  const [consignee, setConsignee] = useState("");
  const [nowConsignee, setNowConsignee] = useState("");
  const [consigneeOn, setConsigneeOn] = useState(false);

  const [notyfyParty, setNotyfyParty] = useState("");
  const [nowNotyfyParty, setNowNotyfyParty] = useState("");
  const [notyfyPartyOn, setNotyfyPartyOn] = useState(false);

  const [deliverGoods, setDeliverGoods] = useState("");
  const [nowDeliverGoods, setNowDeliverGoods] = useState("");
  const [deliverGoodsOn, setDeliverGoodsOn] = useState(false);

  try {
    useEffect(() => {
      fetch(`${baseUrl}${pageComponent}/getBLNO`)
        .then((response) => response.json())
        .then((data) => {
          setBlNumList(data.blno);
          console.log(data);
        });
    }, []);
  } catch (error) {
    if (error.response && error.response.status === 429) {
    } else {
      console.error(error);
    }
  }

  const houseBLVal = (e) => {
    setHouseBLOn(true);
    setNowHouseBL(e);
  };

  const dateVal = (e) => {
    setBLDateOn(true);
    setNowBLDate(e);
  };
  const placeofDeliveryVal = (e) => {
    setPlaceofDeliveryOn(true);
    setNowPlaceofDelivery(e);
  };
  const preCarrageByVal = (e) => {
    setPreCarrageByOn(true);
    setNowPreCarrageBy(e);
  };
  const placeOfReceiptVal = (e) => {
    setPlaceOfReceiptOn(true);
    setNowPlaceOfReceipt(e);
  };
  const finalDestinationVal = (e) => {
    setFinalDestinationOn(true);
    setNowFinalDestination(e);
  };
  const grossWeightVal = (e) => {
    setGrossWeightOn(true);
    setNowGrossWeight(e);
  };
  const noOfContVal = (e) => {
    setNoOfContOn(true);
    setNowNoOfCont(e);
  };
  const mesurementVal = (e) => {
    setMesurementOn(true);
    setNowMesurement(e);
  };
  const shipperVal = (e) => {
    setShipperOn(true);
    setNowShipper(e);
  };
  const noOfContInWordsVal = (e) => {
    setNoOfContInWordsOn(true);
    setNowNoOfContInWords(e);
  };
  const consigneeVal = (e) => {
    setConsigneeOn(true);
    setNowConsignee(e);
  };
  const notyfyPartyVal = (e) => {
    setNotyfyPartyOn(true);
    setNowNotyfyParty(e);
  };
  const deliverGoodsVal = (e) => {
    setDeliverGoodsOn(true);
    setNowDeliverGoods(e);
  };

  const selectBooking = (id) => {
    let blNow = id;
    console.log(blNow);
  };

  onhadlePlaceofDelivery(
    nowPlaceofDelivery !== "" ? nowPlaceofDelivery : placeofDelivery
  );
  onhadleMasterBL(selectedBLNO);
  onhadleHouseBL(nowHouseBL !== "" ? nowHouseBL : houseBL);
  onhadleBLDate(nowBLDate !== "" ? nowBLDate : bLDate);
  onhadleVesCode(vesCode);
  onhadleVesDesc(vesDesc);
  onhadlevoyCode(voyCode);
  onhadleVoyDesc(voyDesc);
  onhadlePolCode(polCode);
  onhadlePolDesc(polDesc);
  onhadlepodCode(podCode);
  onhadlepodDesc(podDesc);
  onhadlePlaceOfReceipt(
    NowPlaceOfReceipt !== "" ? NowPlaceOfReceipt : placeOfReceipt
  );
  onhadlePreCarrageBy(NowPreCarrageBy !== "" ? NowPreCarrageBy : preCarrageBy);
  onhadleFinalDestination(
    NowFinalDestination !== "" ? NowFinalDestination : finalDestination
  );
  onhadleGrossWeight(NowgrossWeight !== "" ? NowgrossWeight : grossWeight);
  onhadleNoOfCont(nownoOfCont !== "" ? nownoOfCont : noOfCont);
  onhadleMesurement(nowmesurement !== "" ? nowmesurement : mesurement);
  onhadleNoOfContInWords(
    nowNoOfContInWords !== "" ? nowNoOfContInWords : noOfContInWords
  );
  onhadleShipper(nowshipper !== "" ? nowshipper : shipper);
  onhadleConsignee(nowConsignee !== "" ? nowConsignee : consignee);
  onhadleNotyfyParty(nowNotyfyParty !== "" ? nowNotyfyParty : notyfyParty);
  onhadleDeliverGoods(nowDeliverGoods !== "" ? nowDeliverGoods : deliverGoods);

  const flightFirstDateSet = (index, value) => {
    const newInputValues = [...firstFlightDate];
    newInputValues[index] = value;
    setFirstFlightDate(newInputValues);
    if (newInputValues[index].length !== 0) {
      addNewTextBox(index);
    }
  };

  const addNewTextBox = () => {
    console.log();

    if (firstFlightDate[firstFlightDate.lengthn - 0] !== "") {
      setFirstFlightDateTextBoxes(firstFlightDateTextBoxes + 1);
      setFirstFlightDate([...firstFlightDate, ""]);
    }
  };

  return (
    <Container>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-4 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Master BL NO</Form.Label>
                  <Form.Select
                    aria-label=""
                    onChange={(e) => {
                      selectBooking(e.target.value);
                    }}
                  >
                    <option value=""></option>
                    <>
                      {Array.isArray(blNumList)
                        ? blNumList.map((bLItem, id) => (
                            <option value={bLItem.id} key={bLItem.id}>
                              {bLItem.BLNo}
                            </option>
                          ))
                        : ""}
                    </>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>House BL NO</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="House BL NO"
                    autoComplete="off"
                    name="Hbl"
                    value={
                      nowHouseBL
                        ? nowHouseBL
                        : houseBLOn === false
                        ? houseBL
                        : ""
                    }
                    onChange={(e) => houseBLVal(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Date</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder=""
                    autoComplete="off"
                    name="date"
                    value={
                      nowBLDate ? nowBLDate : bLDateOn === false ? bLDate : ""
                    }
                    onChange={(e) => dateVal(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label className="">Vessel</Form.Label>
                  <br />
                  <Form.Label className="printted-label">{vesCode}</Form.Label>
                  <Form.Label className="printted-label ms-3">
                    {vesDesc}
                  </Form.Label>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label className="">Voyage</Form.Label>
                  <br />
                  <Form.Label className="printted-label">{voyCode}</Form.Label>
                  <Form.Label className="ms-3 printted-label">
                    {voyDesc}
                  </Form.Label>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label className="">Poprt of Loading</Form.Label>
                  <br />
                  <Form.Label className="printted-label">{polCode} </Form.Label>
                  <Form.Label className="ms-3 printted-label">
                    {polDesc}
                  </Form.Label>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label className="">Port of disch</Form.Label>
                  <br />
                  <Form.Label className="printted-label">{podCode} </Form.Label>
                  <Form.Label className="ms-3 printted-label">
                    {podDesc}
                  </Form.Label>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Shipper Account</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    value={
                      nowPlaceofDelivery
                        ? nowPlaceofDelivery
                        : placeofDeliveryOn === false
                        ? placeofDelivery
                        : ""
                    }
                    onChange={(e) => placeofDeliveryVal(e.target.value)}
                    autoComplete="off"
                    name="date"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Consignee Acc</Form.Label>
                  <Form.Control
                    type="text"
                    autoComplete="off"
                    value={
                      NowPlaceOfReceipt
                        ? NowPlaceOfReceipt
                        : placeOfReceiptOn === false
                        ? placeOfReceipt
                        : ""
                    }
                    onChange={(e) => placeOfReceiptVal(e.target.value)}
                    placeholder=""
                    name="Vessel"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Agent's IATA Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    value={
                      NowPreCarrageBy
                        ? NowPreCarrageBy
                        : preCarrageByOn === false
                        ? preCarrageBy
                        : ""
                    }
                    onChange={(e) => preCarrageByVal(e.target.value)}
                    autoComplete="off"
                    name=""
                  />
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Account No</Form.Label>
                  <Form.Control
                    type="text"
                    autoComplete=""
                    value={
                      NowFinalDestination
                        ? NowFinalDestination
                        : finalDestinationOn === false
                        ? finalDestination
                        : ""
                    }
                    onChange={(e) => finalDestinationVal(e.target.value)}
                    placeholder=""
                    name="BlNo"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>AirPort Of Destination</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    value={
                      NowgrossWeight
                        ? NowgrossWeight
                        : grossWeightOn === false
                        ? grossWeight
                        : ""
                    }
                    onChange={(e) => grossWeightVal(e.target.value)}
                    autoComplete="off"
                    name="Hbl"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Declared value For Carrige</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    value={
                      NowPreCarrageBy
                        ? NowPreCarrageBy
                        : preCarrageByOn === false
                        ? preCarrageBy
                        : ""
                    }
                    onChange={(e) => preCarrageByVal(e.target.value)}
                    autoComplete="off"
                    name=""
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Declared value For Customs</Form.Label>
                  <Form.Control
                    type="text"
                    autoComplete=""
                    value={
                      NowFinalDestination
                        ? NowFinalDestination
                        : finalDestinationOn === false
                        ? finalDestination
                        : ""
                    }
                    onChange={(e) => finalDestinationVal(e.target.value)}
                    placeholder=""
                    name="BlNo"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Amount Of Insurance</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    value={
                      NowgrossWeight
                        ? NowgrossWeight
                        : grossWeightOn === false
                        ? grossWeight
                        : ""
                    }
                    onChange={(e) => grossWeightVal(e.target.value)}
                    autoComplete="off"
                    name="Hbl"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Currency</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    value={
                      nownoOfCont
                        ? nownoOfCont
                        : noOfContOn === false
                        ? noOfCont
                        : ""
                    }
                    onChange={(e) => noOfContVal(e.target.value)}
                    autoComplete="off"
                    name="date"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Chgs Code</Form.Label>
                  <Form.Control
                    type="text"
                    autoComplete=""
                    value={
                      nowmesurement
                        ? nowmesurement
                        : mesurementOn === false
                        ? mesurement
                        : ""
                    }
                    onChange={(e) => mesurementVal(e.target.value)}
                    placeholder=""
                    name="Vessel"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>PDD</Form.Label>

                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    value={
                      nowNoOfContInWords
                        ? nowNoOfContInWords
                        : noOfContInWordsOn === false
                        ? noOfContInWords
                        : ""
                    }
                    onChange={(e) => noOfContInWordsVal(e.target.value)}
                    name="date"
                  />
                </Form.Group>
              </Col>
              <Col className="text-center">
                {" "}
                <Form.Label>WT/VAT</Form.Label>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>COLL</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    value={
                      nowNoOfContInWords
                        ? nowNoOfContInWords
                        : noOfContInWordsOn === false
                        ? noOfContInWords
                        : ""
                    }
                    onChange={(e) => noOfContInWordsVal(e.target.value)}
                    name="date"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>PPD</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    value={
                      nowNoOfContInWords
                        ? nowNoOfContInWords
                        : noOfContInWordsOn === false
                        ? noOfContInWords
                        : ""
                    }
                    onChange={(e) => noOfContInWordsVal(e.target.value)}
                    name="date"
                  />
                </Form.Group>
              </Col>
              <Col className="text-center">
                {" "}
                <Form.Label>Other</Form.Label>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>COLL</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    value={
                      nowNoOfContInWords
                        ? nowNoOfContInWords
                        : noOfContInWordsOn === false
                        ? noOfContInWords
                        : ""
                    }
                    onChange={(e) => noOfContInWordsVal(e.target.value)}
                    name="date"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Shipper</Form.Label>
                  <Form.Control
                    as="textarea"
                    value={
                      nowshipper
                        ? nowshipper
                        : shipperOn === false
                        ? shipper
                        : ""
                    }
                    onChange={(e) => shipperVal(e.target.value)}
                    placeholder=""
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Consignee</Form.Label>
                  <Form.Control
                    as="textarea"
                    value={
                      nowConsignee
                        ? nowConsignee
                        : consigneeOn === false
                        ? consignee
                        : ""
                    }
                    onChange={(e) => consigneeVal(e.target.value)}
                    placeholder=""
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Notify Party</Form.Label>
                  <Form.Control
                    as="textarea"
                    value={
                      nowNotyfyParty
                        ? nowNotyfyParty
                        : notyfyPartyOn === false
                        ? notyfyParty
                        : ""
                    }
                    onChange={(e) => notyfyPartyVal(e.target.value)}
                    placeholder=""
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label> Handling Information</Form.Label>
                  <Form.Control
                    as="textarea"
                    value={
                      nowDeliverGoods
                        ? nowDeliverGoods
                        : deliverGoodsOn === false
                        ? deliverGoods
                        : ""
                    }
                    onChange={(e) => deliverGoodsVal(e.target.value)}
                    placeholder="For delovery of goods please here"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>To</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder=""
                        autoComplete="off"
                        value={
                          nowNoOfContInWords
                            ? nowNoOfContInWords
                            : noOfContInWordsOn === false
                            ? noOfContInWords
                            : ""
                        }
                        onChange={(e) => noOfContInWordsVal(e.target.value)}
                        name="date"
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>To</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder=""
                        autoComplete="off"
                        value={
                          nowNoOfContInWords
                            ? nowNoOfContInWords
                            : noOfContInWordsOn === false
                            ? noOfContInWords
                            : ""
                        }
                        onChange={(e) => noOfContInWordsVal(e.target.value)}
                        name="date"
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>By</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder=""
                        autoComplete="off"
                        value={
                          nowNoOfContInWords
                            ? nowNoOfContInWords
                            : noOfContInWordsOn === false
                            ? noOfContInWords
                            : ""
                        }
                        onChange={(e) => noOfContInWordsVal(e.target.value)}
                        name="date"
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>To</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder=""
                        autoComplete="off"
                        value={
                          nowNoOfContInWords
                            ? nowNoOfContInWords
                            : noOfContInWordsOn === false
                            ? noOfContInWords
                            : ""
                        }
                        onChange={(e) => noOfContInWordsVal(e.target.value)}
                        name="date"
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>By</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder=""
                        autoComplete="off"
                        value={
                          nowNoOfContInWords
                            ? nowNoOfContInWords
                            : noOfContInWordsOn === false
                            ? noOfContInWords
                            : ""
                        }
                        onChange={(e) => noOfContInWordsVal(e.target.value)}
                        name="date"
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>For Carrier Use Only</Form.Label>
                    </Form.Group>
                  </Col>
                </Row>
              </Col>

              <Col>
                <Row>
                  <Col>
                    {firstFlightDate.map((value, index) => (
                      <Row>
                        <Col>
                          <Form.Group className="mb-3">
                            <Form.Label>Flight/Dates 1</Form.Label>
                            <Form.Control
                              type="text"
                              key={index}
                              placeholder=""
                              autoComplete="off"
                              onBlur={(e) =>
                                flightFirstDateSet(index, e.target.value)
                              }
                            />
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group className="mb-3">
                            <Form.Label>Flight/Dates 2</Form.Label>
                            <Form.Control
                              type="text"
                              key={index}
                              placeholder=""
                              autoComplete="off"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    ))}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default AirwayBillFirstPage;
